import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { User, Price } from './';

@Model()
export default class Subscription extends ApplicationRecord {
  static jsonapiType = 'subscriptions';

  static scopeFactory() {
    return Subscription.includes([]);
  }

  @Attr() endDatetime: string;
  @Attr() canceledAt: string;
  @Attr() valid: boolean;

  @HasOne() user: User;
  @HasOne() price: Price;
}
